import { Container, Graphics } from "pixi.js";
import { indoor } from "./common.js";

/** Bloque 11A: decanato. Ventanillas de atención y sala de espera. */
export function decanato(): Container {
  const scene = indoor({ wall: 0xe4e9ef, floor: 0xbfc7cf });

  /*
   * Las mamparas van justo detrás de donde está la ventanilla del catálogo.
   *
   * El mueble lo dibuja el motor; esto es la pared con los cristales, que es lo que
   * hace que se lea como atención al público y no como una mesa suelta.
   */
  const booths = new Graphics();
  booths.rect(280, 96, 400, 120).fill(0xf4f7fa).stroke({ width: 4, color: 0x9aa6b2 });
  for (let i = 0; i < 3; i++) {
    const x = 300 + i * 130;
    booths
      .rect(x, 116, 100, 80)
      .fill({ color: 0xa8cfe4, alpha: 0.75 })
      .stroke({ width: 3, color: 0x7f909f });
    booths.rect(x + 20, 196, 60, 8).fill(0x7f909f);
  }
  scene.addChild(booths);

  const crest = new Graphics();
  crest.circle(150, 140, 44).fill(0x1b3f6b).stroke({ width: 5, color: 0xe8c33c });
  crest.rect(128, 122, 44, 36).fill(0xe8c33c);
  scene.addChild(crest);

  const plant = new Graphics();
  plant.rect(820, 180, 44, 46).fill(0xb07a4a);
  plant.circle(842, 168, 34).fill(0x3f8f4f);
  scene.addChild(plant);

  return scene;
}
